module.exports = __webpack_public_path__ + "static/media/icon_175.1e9093c0.svg";